import {defineMessages} from 'react-intl';

const MESSAGES = defineMessages({
  DESCRIPTION_TITLE: {
    id: 'CookieModal.DescriptionTitle',
    defaultMessage: 'We care about your privacy',
  },
  MANAGEMENT_TITLE: {
    id: 'CookieModal.ManagementTitle',
    defaultMessage: 'Preferences configuration',
  },
  DESCRIPTION_MSG: {
    id: 'CookieModal.DescriptionMSG',
    defaultMessage:
      'To deliver the best possible experience, StubHub International uses cookies to enable site functionality, to analyse site performance and to serve content that is more relevant to you. By clicking "Accept All Cookies", you agree to the storing of cookies on your device for these purposes. For more information see our <a>cookies policy</a>.',
  },
  DESCRIPTION_LINK: {
    id: 'CookieModal.CookieLink',
    defaultMessage: 'cookies policy',
  },
  ACCEPT_BTN: {
    id: 'CookieModal.AcceptBtn',
    defaultMessage: 'Accept All',
  },
  REJECT_BTN: {
    id: 'CookieModal.RejectBtn',
    defaultMessage: 'Reject All',
  },
  MANAGEMENT_BTN: {
    id: 'CookieModal.ManagemetBtn',
    defaultMessage: 'Manage your configuration',
  },
  CONFIRM_BTN: {
    id: 'CookieModal.ConfirmBtn',
    defaultMessage: 'Confirm my preferences',
  },
  IS_ACTIVE_MSG: {
    id: 'CookieModal.IsActive',
    defaultMessage: 'Allow',
  },
  IS_MANDATORY_MSG: {
    id: 'CookieModal.IsMandatory',
    defaultMessage: 'Always Active',
  },
  ESSENTIAL_COOKIES_TITLE: {
    id: 'CookieModal.Essential_cookies',
    defaultMessage: 'Essential cookies',
  },
  ESSENTIAL_COOKIES_DESCRIPTION: {
    id: 'CookieModal.Essential_cookies.description',
    defaultMessage:
      'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.',
  },
  PERFORMANCE_COOKIES_TITLE: {
    id: 'CookieModal.Performance_cookies',
    defaultMessage: 'Performance cookies',
  },
  PERFORMANCE_COOKIES_DESCRIPTION: {
    id: 'CookieModal.Performance_cookies.description',
    defaultMessage:
      'These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.',
  },
  MARKETING_COOKIES_TITLE: {
    id: 'CookieModal.Marketing_cookies',
    defaultMessage: 'Marketing cookies',
  },
  MARKETING_COOKIES_DESCRIPTION: {
    id: 'CookieModal.Marketing_cookies.description',
    defaultMessage:
      'These cookies track your activity around the site to measure the performance of our marketing campaigns, and to help us deliver more relevant marketing communications, such as internet-based advertising, retargeting, and social media ads. In order to do so, these cookies share some of your personal data with third parties like Google Ads, Meta Ads, and TradeDoubler.',
  },
});

export default MESSAGES;
